import type { ReactElement } from 'react';

export type TrendsLegendMetric = {
  key: string;
  name: string;
  color: string;
  imageUrl?: string;
};

/**
 * Recharts legend replacement: optional answer thumbnails (image-only / image answers).
 */
export function SurveyGroupTrendsLegendRows({ metrics }: { metrics: TrendsLegendMetric[] }): ReactElement {
  return (
    <div className="flex w-full flex-wrap justify-center gap-x-3 gap-y-2 px-1 pt-2 text-[11px]">
      {metrics.map((m) => (
        <span
          key={m.key}
          className="inline-flex max-w-[min(100%,220px)] items-center gap-1.5 text-gray-700"
        >
          <span
            className="h-0.5 w-4 shrink-0 rounded-full"
            style={{ background: m.color }}
          />
          {m.imageUrl ? (
            <img
              src={m.imageUrl}
              alt=""
              className="h-8 w-8 shrink-0 rounded-md border border-gray-200 object-cover"
            />
          ) : null}
          <span
            className="min-w-0 truncate"
            title={m.name.replace(/\u00a0/g, ' ').replace(/\u200b/g, '').trim() || (m.imageUrl ? 'Answer option' : m.name)}
          >
            {(() => {
              const t = m.name.replace(/\u00a0/g, ' ').replace(/\u200b/g, '').trim();
              if (t) {
                return t;
              }
              return m.imageUrl ? null : m.name;
            })()}
          </span>
        </span>
      ))}
    </div>
  );
}
